module.exports = __webpack_public_path__ + "assets/img/3_1293_big.8ccb54d7.jpg";